import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const availabilityTypesAdapter = getAdapter({ idFieldName: 'value' });

const availabilityTypesSlice = createSlice({
  name: 'availabilityTypes',
  initialState: availabilityTypesAdapter.getInitialState(),
  reducers: {
    setAvailabilityTypes: (state, { payload: { availabilityTypes } }) => {
      availabilityTypesAdapter.setAll(state, availabilityTypes);
    }
  }
});

const selectors = availabilityTypesAdapter.getSelectors(({ availabilityTypes }) => availabilityTypes);

export const getAvailabilityTypes = state => selectors.selectAll(state);

export const { setAvailabilityTypes } = availabilityTypesSlice.actions;

export default availabilityTypesSlice.reducer;
